import { AlertBox, AlertBoxDismissButton, Box } from '@vp/swan';
import { ReplaceTokens, useTranslations } from '@vp/om-translations';
import React from 'react';
import useSiteData from '../../../hooks/useSiteData';
import { EmbeddableLinkCreator } from '../../shared/EmbeddableLinkCreator';

export const ErrorBanner = () => {
  const [designFeedbackMessages] = useTranslations(['designFeedbackMessages']);

  const { externalAppNavigation } = useSiteData();
  const navToCustomerCare = externalAppNavigation.customerCareContact;
  const ContactCareLink = EmbeddableLinkCreator({
    href: navToCustomerCare,
    tabIndex: 0,
  });

  return (
    <Box style={{ width: '100%' }} mb={6}>
      <AlertBox skin="error">
        {designFeedbackMessages.issueSubmittingFeedback}
        <br />
        <ReplaceTokens
          tokenizedString={designFeedbackMessages.tryAgainOrContact}
          substitutions={{
            ContactCareLink,
          }}
        />
        <AlertBoxDismissButton accessibleText="Dismiss alert" />
      </AlertBox>
    </Box>
  );
};
